<div class="loaderAnimation">
  <div class="loadingGifAnimation clearfix">
    <div class="loadingInner clearfix">
      <img class="logoCenterLoading" src="assets/images/Loader-new.gif" alt="Loader-new" />
    </div>
  </div>
</div>
